import { getIn } from 'final-form';
import React from 'react';
import { useFormState } from 'react-final-form';

const useFormUtils = () => {
  const { initialValues = {} } = useFormState({ subscription: { initialValues: true } });

  /**
   * @param {string} key
   */
  const getInitialValue = React.useCallback(key => getIn(initialValues, key), [initialValues]);

  return { getInitialValue };
};

export default useFormUtils;
